module.exports = __webpack_public_path__ + "img/banner02.a5c536b6.jpg";